import type { QuestionModule } from "../contracts";
import {
  numericCore,
  type NumericDefinition,
  type NumericDraft,
  type NumericEvent,
  type NumericRaw,
  type NumericResponse,
} from "./core";
import { NumericView } from "./views";

export const numericModule: QuestionModule<
  NumericRaw,
  NumericDefinition,
  NumericDraft,
  NumericEvent,
  NumericResponse
> = {
  type: "numeric",
  galleryFeatures: [
    "visual-groups",
    "baseline",
    "blank",
    "zero",
    "restored",
    "adornments",
  ],
  core: numericCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Default",
      component: NumericView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action", "text-input"],
      input: "host-text",
    },
  },
  defaultDisplay: { view: "default" },
  controls: (definition, draft, _display, copy) => ({
    inputHint: "multitext",
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
    ...(definition.dontKnow
      ? {
          secondaryAction: {
            label: definition.dontKnow.label,
            selected: draft.dontKnowSelected,
            action: {
              type: "submit" as const,
              event: { type: "toggle-dont-know" as const },
            },
          },
        }
      : {}),
    textInput: {
      fieldId: "numeric-answer",
      label: copy.labels.yourAnswer,
      value: draft.value,
      multiline: true,
      inputMode: "numeric",
      prefix: definition.prefix,
      suffix: definition.suffix,
      event: (value): NumericEvent => ({ type: "set-value", value }),
    },
  }),
};
